import { FileAssetObj } from "ui-component/extended/Form/CustomFileUpload";

export type GroupPromptObj = {
 ID : number;
 GroupTypeId : number;
 GroupTypeDesc :string;
 PromptContent :string;
}

export type AiResponse = {
    ID: number;
    Title: string;
    PromptType: PromptTypeEnum;
    CustomPrompt: string;
    ResponseText: string;
    ResponseHtml: string;
    ResponseFile: FileAssetObj;
    AnalysisDate: string;
    Inquiry: string;
    IsPending: boolean;
}
export enum OutputTypeEnum {
    RenderedContent = 0,
    GeneratedFile = 1,
    TemplatePptx = 2
}

export enum PromptTypeEnum {
    SystemPrompt = 0,
    MediaPlan = 1,
    MediaPlanCompare = 2,
    MediaPlanReport = 3,
    MediaPlanReportCompare = 4,
    ActivityCompare = 5,
    ActivityReportCompare = 6
}

export type AiConfig = {
    Api: string;   
    Model: string;
    MaxTokens: number;
    Temperature: number;
}